module.exports = __webpack_public_path__ + "static/media/PDF_112.3534ff96.pdf";